const chains = [];
chains.push({ _operation: 'getProfitLossSheetStatementDetailsBySaleType', api: '/profit-loss-sheet-statement-details/:saleType', defaultData: [], httpVerb: 'get' });
export default chains;
